<template lang="pug">
.box
    header.flex.items-center.justify-between.box__header.no-border
        .header-meta
            h2.subheading List Data
        .header-cta
            .flex.items-center
                .relative
                    button.btn-default Export to excel

    template(v-if="load_data_status_browsing.status === 'loading' && load_data_status_browsing_count.history === 'loading'")
        Loading(show="true")
    template(v-else) 
        NoDataAvailable(v-if='filterNull')
        template(v-else-if="browsing_history && browsing_history.length > 0")
            .box__body.p-4
                <v-client-table ref='myTable' :data="tableData" :columns="columns" :options="options">
                    <span slot="no" slot-scope="props">{{props.index}}.</span>
                </v-client-table>  
        NoDataAvailable(v-else)
</template>

<script>
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';

export default {
    name: 'TableListData',
    components: {
        Loading,
        NoDataAvailable,
    },
    data() {
        return {
            filterNull: false,
            columns: ['datetime','provider','rat_name','domain','duration','msisdn','imsi','imei','hostname','server_ip','server_port','web_category','app_category','method','server_delay','ssl','client_ip','client_port','client_delay','browser_name','vol_in','vol_out','vol_total','response_code','referer_category','location','apn','url','referer_url','referer_domain'],
            options: {
                headings: {
                    'rat_name': "Rat Name",
                    'msisdn': "MSISDN",
                    'imsi': "IMSI",
                    'imei': "IMEI",
                    'server_ip': "Server IP",
                    'server_port': "Server Port",
                    'web_category': "Web Category",
                    'app_category': "App Category",
                    'server_delay': "Server Delay",
                    'client_ip': "Client IP",
                    'client_port': "Client Port",
                    'client_delay': "Client Delay",
                    'browser_name': "Browser Name",
                    'vol_in': "Vol In",
                    'vol_out': "Vol Out",
                    'vol_total': "Vol Total",
                    'response_code': "Res Code",
                    'referer_category': "Referer Category",
                    'referer_url': "Referer URL",
                    'referer_domain': "Referer Domain",
                },
                // filterable: false,
                // perPage: 10,
                pagination: { 
                    chunk: 5 
                    // dropdown: false 
                },
                // perPageValues: [10,25,50,100],
                skin: 'table table-overflow',
                // skin: 'table-static w-full p-4',
                sortIcon: { 
                    base:'iconfont',
                    is:'iconsort',
                    up: 'iconup',
                    down: 'icondown'
                },
                columnsClasses: {
                  'datetime': 'font-mini',
                },
            },
            tableData:[]
        }
    },
    mounted () {
        this.getData()

    },
    computed: {
        ...mapState([
          'load_data_status_browsing',
          'load_data_status_browsing_count',
          'browsing_history',
        ]),
    },
    watch:{
        browsing_history() {
            this.getData()
        }

    },
    methods: {
        getData() {
            if (this.browsing_history && this.browsing_history.length > 0) {
                this.tableData = this.browsing_history
                this.filterNull=false
            } else {
                this.filterNull=true
            }
        },
    }
}
</script>
<!-- <script src="vue-tables-2/compiled/themes/bootstrap4.js"></script> -->
<style lang="sass">

</style>
